import ComboDistributionChart from '@/components/Combo/ComboDistributionChart/ComboDistributionChart'
import CornerBackgroundImage from '@/components/Combo/CornerBackgroundImage/CornerBackgroundImage'
import Stat from '@/components/Combo/Stat/Stat'
import Icon from '@/components/Icon/Icon'
import { ComboData } from '@/types/page'
import { artCrop } from '@/utils/images'

import styles from './MetaData.module.scss'

type Props = {
  combo: ComboData
}

const MetaData = ({ combo }: Props) => (
  <div className={styles.infoContainer}>
    {combo.cardIds[1] && <CornerBackgroundImage image={artCrop(combo.cardIds[1])} position='topRight' size={300} />}
    <h2 className={styles.header}>
      <Icon icon='chartSimple' />
      &nbsp;&nbsp;Combo Metadata
    </h2>
    <div className={styles.statContainer}>
      <Stat label='DECKS' value={combo.count} />
      <Stat label={`OF ${combo.maxCount} ELIGIBLE DECKS`} value={`${combo.percentage.toFixed(2)}%`} />
      <Stat label={`MOST PLAYED OF ${combo.totalComboCount} COMBOS`} value={`Rank ${combo.rank}`} />
    </div>
    <ComboDistributionChart combo={combo} />
  </div>
)

export default MetaData
